import type { ReactNode } from "react";

interface AppStatusProps {
  title: string;
  detail?: ReactNode;
  isError?: boolean;
}

export function AppStatus({ title, detail, isError = false }: AppStatusProps) {
  return (
    <div className="flex h-screen w-screen flex-col items-center justify-center gap-4 font-sans text-foreground">
      <div className={isError ? "text-xl text-destructive" : undefined}>
        {title}
      </div>
      {detail && <div className="text-sm">{detail}</div>}
    </div>
  );
}
